import { apiPaths } from 'configs/apiConfigs'
import { httpTenantsService } from 'utils/http'
import { IOaiUserStub, IOaiUserUpdate, OaiUserCreate, OaiUserInvitation } from './types/userTypes'

export const cppuCreateOaiUser = async (
  oaiUserInvitation: OaiUserInvitation | OaiUserCreate,
): Promise<IOaiUserStub> => {
  const { data } = await httpTenantsService.post(apiPaths.cppuCreateOaiUser(), oaiUserInvitation)
  return data
}

export const cppuResendInvitation = async (username: string): Promise<string> => {
  const { data } = await httpTenantsService.post(apiPaths.cppuResendInvitation(username), username)
  return data
}

export const cppuChangePassword = async (username: string): Promise<string> => {
  const { data } = await httpTenantsService.post(apiPaths.cppuChangePassword(username), username)
  return data
}

export const cppuDisableUser = async (userId: string, status: boolean): Promise<string> => {
  const { data } = await httpTenantsService.put(apiPaths.cppuDisableUser(userId, status))
  return data
}

export const cppuUpdateOaiUser = async (oaiUserUpdate: IOaiUserUpdate): Promise<IOaiUserStub> => {
  const { data } = await httpTenantsService.patch(apiPaths.cppuPatchOaiUser(), oaiUserUpdate)
  return data
}
export const cppuGetOaiUser = async (query: string): Promise<any> => {
  const { data } = await httpTenantsService.get(apiPaths.cppuGetOaiUser() + `?${query}`)
  return data.data
}

export const refreshCognito = async (query: string): Promise<any> => {
  const { data } = await httpTenantsService.post(apiPaths.cppuCognitoRefresh() + `?${query}`)
  return data.data
}

export const keycloakRefresh = async (userId: string) => {
  const { data } = await httpTenantsService.post(apiPaths.keycloakRefresh(userId))
  return data
}
